var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.927,
    height: 45.827,
    viewBox: "0 0 45.927 45.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design_4_",
    "data-name": "design(4)",
    transform: "translate(-1.458 -1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_240",
    "data-name": "Ellipse 240",
    cx: 9.224,
    cy: 9.224,
    r: 9.224,
    transform: "translate(3.058 27.378)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21919",
    "data-name": "Path 21919",
    d: "M26.972,21.119H12.147A1.556,1.556,0,0,1,10.5,19.472V4.647A1.556,1.556,0,0,1,12.147,3H26.972a1.556,1.556,0,0,1,1.647,1.647V19.472A1.556,1.556,0,0,1,26.972,21.119Z",
    transform: "translate(17.266 0)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21920",
    "data-name": "Path 21920",
    d: "M27.087,28.734A1.21,1.21,0,0,1,26.1,28.4L10.944,13.25a1.631,1.631,0,0,1,2.306-2.306L28.4,26.1a1.592,1.592,0,0,1,0,2.306c-.329.329-.659.329-1.318.329Z",
    transform: "translate(17.152 17.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21921",
    "data-name": "Path 21921",
    d: "M12.162,28.734a1.21,1.21,0,0,0,.988-.329L28.3,13.25A1.631,1.631,0,1,0,26,10.944L10.844,26.1a1.592,1.592,0,0,0,0,2.306,2.49,2.49,0,0,0,1.318.329Z",
    transform: "translate(16.922 17.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21922",
    "data-name": "Path 21922",
    d: "M19.86,20.947H4.706A1.514,1.514,0,0,1,3.058,18.97L10.636,3.816c.659-.988,2.306-.988,2.635,0L20.848,18.97A1.208,1.208,0,0,1,19.86,20.947Z",
    transform: "translate(0 0.172)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.82111e7706ecf376a6d994c638e4adcc.svg";
export { ForwardRef as ReactComponent };